import Typography from '~/shared/components/Typography';

export default function AutoscaleRulesLegend() {
  return (
    <div className="flex gap-4 items-center">
      <div className="flex gap-1 items-center">
        <div className="bg-[#D899FF] aspect-square size-4 rounded-[3.2px] " />
        <Typography variant="p3" fontWeight={500} color="text-gray-700" className="">
          Cluster
        </Typography>
      </div>
      <div className="flex gap-1 items-center">
        <div className="bg-[#F9E59B] aspect-square size-4 rounded-[3.2px] " />
        <Typography variant="p3" fontWeight={500} color="text-gray-700" className="">
          Node group
        </Typography>
      </div>
      <div className="flex gap-1 items-center">
        <div className="bg-[#BBCAFF] aspect-square size-4 rounded-[3.2px] " />
        <Typography variant="p3" fontWeight={500} color="text-gray-700" className="">
          Instance
        </Typography>
      </div>
      <div className="flex gap-1 items-center">
        <div className="bg-[#BBCAFF] aspect-square size-4 rounded-[3.2px] " />
        <Typography variant="p3" fontWeight={500} color="text-gray-700" className="">
          Instance tag
        </Typography>
      </div>
      <div className="flex gap-1 items-center">
        <div className="bg-[#D7E3F6] aspect-square size-4 rounded-[3.2px] " />
        <Typography variant="p3" fontWeight={500} color="text-gray-700" className="">
          Volume tag
        </Typography>
      </div>
    </div>
  );
}
